// Keep the UI language in step with the signed-in user: their saved
// choice (``users.locale``) when they have one, the browser's
// preference otherwise and after logout. Imported once from main.tsx.

import { useAuth } from "@/auth/stub";

import { applyUserLanguage } from "./index";

useAuth.subscribe((state, previous) => {
  const locale = state.user?.locale ?? null;
  if (
    state.user === previous.user &&
    locale === (previous.user?.locale ?? null)
  ) {
    return;
  }
  applyUserLanguage(locale);
});
